<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>My favort </h2>
                    <p class="mt-4 mb-0 mx-3">Explore our menu and satisfy every craving — from cheesy pizzas to juicy burgers.</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<section class="realMenuItems mt-4">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mt-5 items">
                <div class="row w-100" *ngIf="!isLoading">
                    <!-- Dynamic Wishlist Items -->
                    <div class="col-lg-12 w-100 mt-3 p-0" *ngFor="let product of myWishListItems" style="background-color: #003921;border-radius: 100px;">
                        
                        <div class="menu-item-card">
                            <div class="card-image-container">
                                <a href="product-details/{{product.id}}/{{product.name}}">
                                    <img src="{{product.avatar}}" class="card-image" alt="{{product.name}}">
                                </a>
                            </div>
                                    
                            <div class="card-content ms-2">
                                <h3 class="card-title">
                                    {{product.name}} 
                                    <label *ngIf="product.offer" class="offer-badge">{{ getOfferText(product.offer) }}</label>
                                </h3>
                                
                                <p class="card-description" *ngIf="product.components">{{product.components}}</p>
                                
                                <div class="card-footer">
                                    <div class="price"><span *ngIf="product.show_price == 1" >{{product.types[0].price | currency}}</span></div>
                                    <div class="card-actions">
                                        <a href="product-details/{{product.id}}/{{product.name}}" class="cart-btn"> <!--(click)="selectProduct(product.id)"-->
                                            <i class="bx bx-cart"></i>
                                        </a>
                                        <a (click)="toggleFav(product.id)" class="favorite-btn">
                                            <i class="bx bx-heart heart text-danger" [class.bxs-heart]="product.isFavorite" [class.text-danger]="product.isFavorite"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- <div class="menu-container">
                            <a (click)="toggleFav(item.id)" style="cursor: pointer;">
                                <i class="bx bx-heart heart" [class.bxs-heart]="item.isFavorite" [class.text-danger]="item.isFavorite"></i>
                            </a>
                            <img [src]="item.avatar || '../../../../assets/img/home2/food.png'" class="itemImage" height="200" width="200" alt="Images">
                            <div class="item-data">
                                <h2>{{item.name}}</h2>
                                <p class="itemDesc">
                                    Waiting for backend to return description
                                </p>
                                <span>
                                    <span *ngIf="item.show_price == 1" class="price">{{getMinPrice(item.types)}} $</span>  
                                    <button class="btn btn-primary" data-bs-toggle="modal" 
                                        data-bs-target="#itemModalDetails" (click)="selectProduct(item.id)">Order Now</button>
                                    <span class="clear-both"></span>
                                </span> 
                            </div>
                        </div> -->
                    </div>
                    <div class="col-12" *ngIf="myWishListItems.length === 0">
                        <div class="alert alert-danger p-4 text-center">
                            <strong>Oops!</strong> No Items Found in your Wishlist
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="isLoading">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

                <!-- Pagination - Keeps your design but makes it functional -->
                <div class="row mt-4" *ngIf="data?.totalPages > 1">
                    <div class="col-12 text-center">
                        <button class="btn btn-outline-secondary me-2" 
                                (click)="prevPage()" 
                                [disabled]="pageNumber === 1">
                            Previous
                        </button>
                        <span class="mx-2">Page {{pageNumber}} of {{data?.totalPages}}</span>
                        <button class="btn btn-outline-secondary ms-2" 
                                (click)="nextPage()" 
                                [disabled]="pageNumber === data?.totalPages">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>